import { render, staticRenderFns } from "./tabServiceApply.vue?vue&type=template&id=2f4c0f90&"
import script from "./tabServiceApply.vue?vue&type=script&lang=ts&"
export * from "./tabServiceApply.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports